module.exports = __webpack_public_path__ + "static/media/igone.999af44b.webp";